import { render } from "./usermgt.vue?vue&type=template&id=919f52f4&scoped=true"
import script from "./usermgt.vue?vue&type=script&lang=js"
export * from "./usermgt.vue?vue&type=script&lang=js"

import "./usermgt.vue?vue&type=style&index=0&id=919f52f4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-919f52f4"]])

export default __exports__